import { render } from "./user_info.vue?vue&type=template&id=d8539736&scoped=true"
import script from "./user_info.vue?vue&type=script&lang=js"
export * from "./user_info.vue?vue&type=script&lang=js"

import "./user_info.vue?vue&type=style&index=0&id=d8539736&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8539736"]])

export default __exports__